import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "app/store";

export const selectGeozones = (state: RootState) =>
  state.rootReducer.geozonesStore.geozones;

export const selectIsLoadingGeozones = (state: RootState) =>
  state.rootReducer.geozonesStore.isLoadingGeozones;

export const selectGeozonesState = createSelector(
  selectGeozones,
  selectIsLoadingGeozones,
  (geozones, isLoadingGeozones) => ({
    geozones,
    isLoadingGeozones
  })
);
